import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { ShopDetailsErrorModal } from "./component";
import {
  getPremierCollectionShopDetailsSelectedLodgingData,
  hasPremierCollectionShopDetailsFailed,
} from "../../reducer/selectors";
import { IStoreState } from "../../../../reducers/types";

const mapStateToProps = (state: IStoreState) => ({
  hasFailed: hasPremierCollectionShopDetailsFailed(state),
  lodging: getPremierCollectionShopDetailsSelectedLodgingData(state),
});

const connector = connect(mapStateToProps);

export type ShopDetailsErrorModalConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedShopDetailsErrorModal = withRouter(connector(ShopDetailsErrorModal));
